import { jsx as _jsx } from "react/jsx-runtime";
import Legal from '~components/legal';
const ServiceAgreement = () => _jsx(Legal, { id: "service-agreement" });
export default ServiceAgreement;
